import React, { useState, useEffect } from "react";
import {
  Alert,
  FormLabel,
  FormGroup,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import SchoolIcon from "@mui/icons-material/School";
import GroupIcon from "@mui/icons-material/Group";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProfileEdit = (props) => {
  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);

  const [state, setState] = React.useState({
    username: "",
    groups: [],
    password: "",
    password2: "",
    errorMessage: "",
    right: false,
    radioList: "A",
    active: "1",
    showPassword: false,
    showPassword2: false,
  });

  const [userlist, setusers] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleClickShowPassword2 = () => {
    setState({
      ...state,
      showPassword2: !state.showPassword2,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (state.password !== state.password2) {
      setState({ errorMessage: "The passwords doesn't match" });
    } else {
      const register = {
        username: state.username,
        password: state.password,
        groups: state.groups.toString(),
        active: state.active,
      };
      const ProfileID = props.ProfileID;
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/user/${ProfileID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(register),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.reload();
        });
    }
  };

  useEffect(() => {
    const ProfileID = props.ProfileID;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/user_list/${ProfileID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
          window.location.href = "/access_denied";
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  return (
    <>
      <button
        className="bg-emerald-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        onClick={toggle}
        size="sm"
        style={{ marginLeft: "26px" }}
        disabled={props.Disabled}
      >
        Edit
      </button>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <form>
            <div className="head" style={{ height: "80px" }}>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  color: "rgb(48, 68, 115)",
                  fontFamily: "sans-serif",
                  lineHeight: "4.5rem",
                }}
              >
                EDIT USER
              </h2>
            </div>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="username" className="ml-4">
                <strong>Username</strong>
              </FormLabel>

              <TextField
                fullWidth
                htmlFor="username"
                placeholder={userlist.username}
                id="username"
                className="form-control"
                value={state.username}
                onChange={handleChange}
                type="text"
                name="username"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SchoolIcon />
                    </InputAdornment>
                  ),
                }}
                size="small"
              />
            </FormGroup>

            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="groups" className="ml-4">
                <strong>Group</strong>
              </FormLabel>

              <TextField
                fullWidth
                htmlFor="groups"
                placeholder={userlist.groups}
                type="select"
                autoComplete="groups"
                name="groups"
                id="groups"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GroupIcon />
                    </InputAdornment>
                  ),
                }}
                className="form-control"
                value={state.groups}
                onChange={handleChange}
                size="small"
                select
                SelectProps={{ native: true }}
              >
                {userlist.groups == 1 ? (
                  <React.Fragment>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                    <option value="4">Remedy</option>
                  </React.Fragment>
                ) : userlist.groups == 2 ? (
                  <React.Fragment>
                    <option value="2">Read-Only</option>
                    <option value="1">Admin</option>
                    <option value="3">OPS</option>
                    <option value="4">Remedy</option>
                  </React.Fragment>
                ) : userlist.groups == 3 ? (
                  <React.Fragment>
                    <option value="3">OPS</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="4">Remedy</option>
                  </React.Fragment>
                ) : userlist.groups == 4 ? (
                  <React.Fragment>
                    <option value="4">Remedy</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </TextField>
            </FormGroup>

            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="password" className="ml-4">
                <strong>Password</strong>
              </FormLabel>
              <OutlinedInput
                fullWidth
                htmlFor="password"
                placeholder="password"
                type={state.showPassword ? "text" : "password"}
                autoComplete="new-password"
                name="password"
                id="password"
                className="form-control"
                value={state.password}
                onChange={handleChange}
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <LockOpenIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormGroup>

            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="password2" className="ml-4">
                <strong>Confirm Password</strong>
              </FormLabel>
              <OutlinedInput
                fullWidth
                placeholder="Confirm password"
                type={state.showPassword2 ? "text" : "password"}
                autoComplete="confirm password"
                name="password2"
                id="password2"
                className="form-control"
                value={state.password2}
                onChange={handleChange}
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <LockOpenIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword2}
                      onMouseDown={handleMouseDownPassword2}
                    >
                      {state.showPassword2 ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormGroup>
          </form>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="submit"
            onClick={handleSubmitClick}
          >
            Update
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProfileEdit;